if (!customElements.get('card-product')) {
  class CardProduct extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.image = this.querySelector('[data-image-wrapper] img')
    }

    updateImage(url) {
      if (!url || !this.image) {
        return
      }

      const srcset = `${url.replace('/width=\d*/', 375 )} 375w, ${url.replace('/width=\d*/', 550 )} 550w, ${url.replace('/width=\d*/', 750 )} 750w, `
      this.image.src = url;
      this.image.srcset = srcset
    }
  }
  customElements.define('card-product', CardProduct);
}
